import { render, staticRenderFns } from "./ExternalSystemsTable.vue?vue&type=template&id=0c83c4ae&scoped=true&"
import script from "./ExternalSystemsTable.vue?vue&type=script&lang=js&"
export * from "./ExternalSystemsTable.vue?vue&type=script&lang=js&"
import style0 from "./ExternalSystemsTable.vue?vue&type=style&index=0&id=0c83c4ae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c83c4ae",
  null
  
)

export default component.exports